"use client"

import { Particles } from "@kit/ui/particles"

interface BackgroundParticlesProps {
  quantity?: number
}

export function BackgroundParticles({ quantity = 250 }: BackgroundParticlesProps) {
  return (
    <Particles
      className="particles h-full w-full"
      quantity={quantity}
      ease={80}
      color={'#ffffff'}
      refresh
    />
  )
}
